export default "__VITE_ASSET__Cor3NBnd__"